import React from 'react'
import './style/Footer.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'

function Footer() {
    return (
        <div className="footer">
            <div>Desig<span>ner</span></div>
            <div className="footer__socialIcon">
                    <div> <FontAwesomeIcon icon={faFacebookF} /></div>
                    <div> <FontAwesomeIcon icon={faTwitter} /></div>
                    <div> <FontAwesomeIcon icon={faInstagram} /></div>
                    <div> <FontAwesomeIcon icon={faLinkedinIn} /></div>
            </div>
            <span>hello.designer@gmail.com</span>
            <ul>
                    <li> <a href="#home">Home</a> </li>
                    <li><a href="#about">About Us</a></li>
                    <li><a href="#service">Service</a></li>
                    <li><a href="#portfolio">Portfolio</a></li>
                    <li><a href="#pricing">Pricing</a></li>
                    <li><a href="#contact">Contact Us</a></li>
                </ul>
                <div className="copyRight">&copy;copyright 2020 Developed By Omar Ghozzi. All rights reserved</div>
        </div>
    )
}

export default Footer
